import type { ConsentConfiguration } from '@maestro/commerce-blocks/theme/theme.types'
import type { Consent } from '@maestro/data-layer'

import { z } from 'zod'

import {
  nameField,
  phoneNumberField,
} from '@maestro/commerce-blocks/schemas/fields'
import { authSchema } from '@maestro/commerce-blocks/schemas/forms/auth.schema'
import { m } from '@maestro/commerce-blocks/schemas/helpers'

export const createRegisterFormSchema = (
  consents: Consent[],
  consentConfigurations: ConsentConfiguration[]
) => {
  const consentFields = consents.reduce(
    (acc, consent) => {
      const consentConfig = consentConfigurations.find(
        (cc) => cc.id === consent.id
      )
      if (consentConfig?.isRequired) {
        acc[consent.id] = z.coerce
          .boolean()
          .refine((val) => val, {
            message: m(`${consent.id}.required`),
          })
          .default(false)
        return acc
      }
      acc[consent.id] = z.coerce.boolean().default(false).optional()
      return acc
    },
    {} as Record<string, z.ZodType>
  )

  return authSchema.extend({
    firstName: nameField('first-name'),
    lastName: nameField('last-name'),
    phone: phoneNumberField,
    consents: z.object(consentFields),
  })
}
